import { parse } from "date-fns";
import { useState, useEffect } from "react";

export const classNames = (
  ...classes: (string | boolean | undefined | null)[]
) => classes.filter(Boolean).join(" ");

function getWindowDimensions() {
  if (typeof window !== "undefined") {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  } else {
    return {};
  }
}

export const parseDate = (dateString = "") => {
  if (!dateString) return null;
  const parsedDate = parse(dateString, "MM/dd/yyyy", new Date());
  return isNaN(parsedDate.getTime()) ? null : parsedDate;
};

export function useWindowDimensions() {
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return windowDimensions;
}

export function formatNumber(n: string) {
  return n.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export function formatCurrency(e: any) {
  const input_val = e.target.value;

  if (input_val === "") {
    return;
  }

  e.target.value = formatNumber(input_val);
}

export function capitalize(s: string) {
  return s[0].toUpperCase() + s.slice(1);
}

export function columnSpan(tags: [string]) {
  return tags.map((tag: string) => {
    if (tag === "two-column-text") {
      return "equal";
    } else if (tag === "image-size-wide") {
      return "wider-left";
    } else {
      return "equal";
    }
  })[0];
}

export function parseLink(sanityLink: any) {
  if (!sanityLink) return null;

  return (
    sanityLink.reference?.slug?.current || sanityLink.path || sanityLink.url
  );
}
